var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.5C13.933 15.5 15.5 13.933 15.5 12C15.5 10.067 13.933 8.5 12 8.5C10.067 8.5 8.5 10.067 8.5 12C8.5 13.933 10.067 15.5 12 15.5Z",
    stroke: "#1B08B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.188 10.934C20.576 11.406 20.77 11.641 20.77 12C20.77 12.359 20.576 12.594 20.188 13.066C18.768 14.79 15.636 18 12 18C8.36398 18 5.23198 14.79 3.81198 13.066C3.42398 12.594 3.22998 12.359 3.22998 12C3.22998 11.641 3.42398 11.406 3.81198 10.934C5.23198 9.21 8.36398 6 12 6C15.636 6 18.768 9.21 20.188 10.934Z",
    stroke: "#1B08B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.c617782bd7c4c9df470238d6c4f807cd.svg";
export { ForwardRef as ReactComponent };